(() => {
  'use strict';
  function prepareImages(root) {
    root.querySelectorAll('.dev-image').forEach((image) => {
      let fallbacks = [];
      try {
        const sources = JSON.parse(image.getAttribute('data-developer-image-fallbacks') || '[]');
        if (Array.isArray(sources)) {
          fallbacks = [...new Set(sources)].filter((url) => typeof url === 'string'
            && url.startsWith('/img-thumb.php?') && url !== image.getAttribute('src'));
        }
      } catch { /* Нет списка альтернатив — остаётся основной рендер. */ }
      function nextImage() {
        // После смены src может прийти запоздалое событие предыдущего запроса.
        if (!image.complete) return;
        const next = fallbacks.shift();
        if (next) {
          image.loading = 'eager';
          image.src = next;
          return;
        }
        image.removeEventListener('error', nextImage);
        image.removeEventListener('load', checkImage);
        image.hidden = true;
        const figure = image.closest('.dev-brand-cover, .dev-company-cover');
        if (figure) figure.hidden = true;
      }
      function checkImage() {
        // Прокси может вернуть HTTP 200 с прозрачным 1×1 вместо ошибки загрузки.
        if (image.naturalWidth <= 1 || image.naturalHeight <= 1) nextImage();
      }
      image.addEventListener('error', nextImage);
      image.addEventListener('load', checkImage);
      if (image.complete) checkImage();
    });
  }
  prepareImages(document);

  const form = document.getElementById('developer-filters');
  let results = document.getElementById('developer-results');
  const status = document.getElementById('developer-filter-status');
  if (!form || !results || !status) return;

  let pending = null;
  function formUrl() {
    const url = new URL(form.action, window.location.href);
    const data = new FormData(form);
    for (const name of ['city', 'min_projects', 'sort']) {
      const value = data.get(name);
      if (typeof value === 'string' && value !== ''
        && !(name === 'min_projects' && value === '1')
        && !(name === 'sort' && value === 'projects_desc')) url.searchParams.set(name, value);
    }
    return url;
  }

  async function refresh(url, push = true) {
    if (pending) pending.abort();
    const request = new AbortController();
    pending = request;
    results.setAttribute('aria-busy', 'true');
    status.textContent = 'Обновляем список…';
    try {
      const response = await fetch(url, { credentials: 'same-origin', signal: request.signal });
      if (!response.ok) throw new Error('Не удалось получить список');
      const doc = new window.DOMParser().parseFromString(await response.text(), 'text/html');
      const next = doc.getElementById('developer-results');
      if (!next) throw new Error('В ответе нет списка');
      if (pending !== request) return;
      results.replaceWith(next);
      results = next;
      prepareImages(results);
      document.title = doc.title;
      for (const selector of ['link[rel="canonical"]', 'meta[name="description"]', 'meta[name="robots"]']) {
        const current = document.head.querySelector(selector);
        const incoming = doc.head.querySelector(selector);
        if (current && incoming) current.replaceWith(incoming);
        else if (incoming) document.head.append(incoming);
        else if (current) current.remove();
      }
      if (push) window.history.pushState({}, '', url);
      status.textContent = 'Список обновлён';
    } catch (error) {
      if (error.name === 'AbortError' || pending !== request) return;
      status.textContent = 'Не удалось обновить список. Попробуйте ещё раз или откройте результат отдельной страницей.';
      const link = document.createElement('a');
      link.href = url;
      link.className = 'dev-filter-retry';
      link.textContent = 'Открыть результат';
      status.append(' ', link);
    } finally {
      if (pending === request) {
        results.setAttribute('aria-busy', 'false');
        pending = null;
      }
    }
  }

  form.addEventListener('submit', (event) => { event.preventDefault(); refresh(formUrl()); });
  form.addEventListener('change', () => refresh(formUrl()));
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof window.Element)) return;
    const reset = event.target.closest('[data-developer-reset]');
    if (!reset || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    form.elements.namedItem('city').value = '';
    form.elements.namedItem('min_projects').value = '1';
    form.elements.namedItem('sort').value = 'projects_desc';
    refresh(new URL(reset.href));
  });
  window.addEventListener('popstate', () => {
    const url = new URL(window.location.href);
    for (const [name, fallback] of [['city', ''], ['min_projects', '1'], ['sort', 'projects_desc']]) {
      form.elements.namedItem(name).value = url.searchParams.get(name) || fallback;
    }
    refresh(url, false);
  });
})();
